import { GroupedHeaderListProps } from '@/components/lists/GroupedHeaderList/GroupedHeaderList';
import { GroupedHeaderListItem } from '@/components/lists/GroupedHeaderList/GroupedHeaderList.types';
import { TestamentaryEntityTab } from '@/modules/entities/testamentaryEntities/shared/testamentaryEntity.types';
import { EntityKind } from '@/types/schema';

import { RowData } from './FlatBeneficiaryTable.types';
import { TrustBeneficiariesList_BeneficiaryFragment } from './graphql/TrustBeneficiariesList.fragments.generated';
import { TrustBeneficiariesListV2 } from './TrustBeneficiaryListV2';

export type BeneficiaryListVariant = 'expandable' | 'flat';

export interface EmptyStateLabels {
  heading: string;
  buttonText: string;
  description: string;
}

export interface TrustBeneficiariesListProps
  extends Partial<
    GroupedHeaderListProps<TrustBeneficiariesList_BeneficiaryFragment>
  > {
  beneficiariesGroups: GroupedHeaderListItem<TrustBeneficiariesList_BeneficiaryFragment>[];
  // the interactive variant additional distribution context in a tooltip, which doesn't work in print.
  // the print variant prints that extra content in a card below the main row content
  variant?: BeneficiaryListVariant;
  isTestamentaryEntity?: boolean;
  onShowEditEntity?: (shouldShowEditButton: boolean) => void;
  entityKind?: EntityKind;
  rows?: RowData[];
  // Optional override for empty state labels. When provided, these labels will be used
  // instead of the default labels from getEmptyBeneficiariesLabels.
  emptyStateLabels?: EmptyStateLabels;
  /**
   * Optional override for the testamentary entity tab to open when clicking the empty state button.
   * When provided, this takes precedence over the default tab.
   */
  testamentaryEntityInitialTab?: TestamentaryEntityTab;
}

export function TrustBeneficiariesList(props: TrustBeneficiariesListProps) {
  return <TrustBeneficiariesListV2 {...props} />;
}
